import PaymentStrings from "./PaymentStrings";

// Country code to region mapping
const regionMap = {
    // east_asia
    CN: "east_asia", // China
    TW: "east_asia", // Taiwan
    // south_asia
    AF: "south_asia", // Afghanistan
    BD: "south_asia", // Bangladesh
    BT: "south_asia", // Bhutan
    IN: "south_asia", // India
    MV: "south_asia", // Maldives
    NP: "south_asia", // Nepal
    PK: "south_asia", // Pakistan
    LK: "south_asia", // Sri Lanka
    // latin_america
    AR: "latin_america", // Argentina
    BS: "latin_america", // Bahamas
    BB: "latin_america", // Barbados
    BZ: "latin_america", // Belize
    BO: "latin_america", // Bolivia
    BR: "latin_america", // Brazil
    CL: "latin_america", // Chile
    CO: "latin_america", // Colombia
    CR: "latin_america", // Costa Rica
    CU: "latin_america", // Cuba
    DM: "latin_america", // Dominica
    DO: "latin_america", // Dominican Republic
    EC: "latin_america", // Ecuador
    SV: "latin_america", // El Salvador
    GD: "latin_america", // Grenada
    GT: "latin_america", // Guatemala
    GY: "latin_america", // Guyana
    HT: "latin_america", // Haiti
    HN: "latin_america", // Honduras
    JM: "latin_america", // Jamaica
    MX: "latin_america", // Mexico
    NI: "latin_america", // Nicaragua
    PA: "latin_america", // Panama
    PY: "latin_america", // Paraguay
    PE: "latin_america", // Peru
    KN: "latin_america", // Saint Kitts and Nevis
    LC: "latin_america", // Saint Lucia
    VC: "latin_america", // Saint Vincent and the Grenadines
    SR: "latin_america", // Suriname
    TT: "latin_america", // Trinidad and Tobago
    UY: "latin_america", // Uruguay
    VE: "latin_america", // Venezuela
    // southeast_asia
    BN: "southeast_asia", // Brunei
    KH: "southeast_asia", // Cambodia
    ID: "southeast_asia", // Indonesia
    LA: "southeast_asia", // Laos
    MY: "southeast_asia", // Malaysia
    MM: "southeast_asia", // Myanmar
    PH: "southeast_asia", // Philippines
    TH: "southeast_asia", // Thailand
    TL: "southeast_asia", // Timor-Leste
    VN: "southeast_asia", // Vietnam
    // africa (excluding South Africa)
    DZ: "africa", // Algeria
    AO: "africa", // Angola
    BJ: "africa", // Benin
    BW: "africa", // Botswana
    BF: "africa", // Burkina Faso
    BI: "africa", // Burundi
    CV: "africa", // Cabo Verde
    CM: "africa", // Cameroon
    CF: "africa", // Central African Republic
    TD: "africa", // Chad
    KM: "africa", // Comoros
    CG: "africa", // Congo
    CD: "africa", // DR Congo
    DJ: "africa", // Djibouti
    EG: "africa", // Egypt
    GQ: "africa", // Equatorial Guinea
    ER: "africa", // Eritrea
    SZ: "africa", // Eswatini
    ET: "africa", // Ethiopia
    GA: "africa", // Gabon
    GM: "africa", // Gambia
    GH: "africa", // Ghana
    GN: "africa", // Guinea
    GW: "africa", // Guinea-Bissau
    CI: "africa", // Ivory Coast
    KE: "africa", // Kenya
    LS: "africa", // Lesotho
    LR: "africa", // Liberia
    LY: "africa", // Libya
    MG: "africa", // Madagascar
    MW: "africa", // Malawi
    ML: "africa", // Mali
    MR: "africa", // Mauritania
    MU: "africa", // Mauritius
    MA: "africa", // Morocco
    MZ: "africa", // Mozambique
    NA: "africa", // Namibia
    NE: "africa", // Niger
    NG: "africa", // Nigeria
    RW: "africa", // Rwanda
    ST: "africa", // Sao Tome and Principe
    SN: "africa", // Senegal
    SC: "africa", // Seychelles
    SL: "africa", // Sierra Leone
    SO: "africa", // Somalia
    SS: "africa", // South Sudan
    SD: "africa", // Sudan
    TG: "africa", // Togo
    TN: "africa", // Tunisia
    UG: "africa", // Uganda
    ZM: "africa", // Zambia
    ZW: "africa", // Zimbabwe
    // middle_east
    BH: "middle_east", // Bahrain
    IR: "middle_east", // Iran
    IQ: "middle_east", // Iraq
    JO: "middle_east", // Jordan
    KW: "middle_east", // Kuwait
    LB: "middle_east", // Lebanon
    OM: "middle_east", // Oman
    PS: "middle_east", // Palestine
    QA: "middle_east", // Qatar
    SA: "middle_east", // Saudi Arabia
    SY: "middle_east", // Syria
    TR: "middle_east", // Turkey
    AE: "middle_east", // United Arab Emirates
    YE: "middle_east", // Yemen
    // eastern_europe (non-EU Eastern Europe)
    AL: "eastern_europe", // Albania
    AM: "eastern_europe", // Armenia
    AZ: "eastern_europe", // Azerbaijan
    BY: "eastern_europe", // Belarus
    BA: "eastern_europe", // Bosnia and Herzegovina
    GE: "eastern_europe", // Georgia
    XK: "eastern_europe", // Kosovo
    MD: "eastern_europe", // Moldova
    ME: "eastern_europe", // Montenegro
    MK: "eastern_europe", // North Macedonia
    RU: "eastern_europe", // Russia
    RS: "eastern_europe", // Serbia
    UA: "eastern_europe", // Ukraine
    // aus_nz
    AU: "aus_nz", // Australia
    NZ: "aus_nz", // New Zealand
    FJ: "aus_nz", // Fiji
    KI: "aus_nz", // Kiribati
    MH: "aus_nz", // Marshall Islands
    FM: "aus_nz", // Micronesia
    NR: "aus_nz", // Nauru
    PW: "aus_nz", // Palau
    PG: "aus_nz", // Papua New Guinea
    WS: "aus_nz", // Samoa
    SB: "aus_nz", // Solomon Islands
    TO: "aus_nz", // Tonga
    TV: "aus_nz", // Tuvalu
    VU: "aus_nz", // Vanuatu
    // outliers
    JP: "outliers", // Japan
    KR: "outliers", // South Korea
    IL: "outliers", // Israel
    SG: "outliers", // Singapore
    // north_america
    US: "north_america", // United States
    CA: "north_america", // Canada
    // eu (EU countries + UK)
    AT: "eu", // Austria
    BE: "eu", // Belgium
    BG: "eu", // Bulgaria
    HR: "eu", // Croatia
    CY: "eu", // Cyprus
    CZ: "eu", // Czech Republic
    DK: "eu", // Denmark
    EE: "eu", // Estonia
    FI: "eu", // Finland
    FR: "eu", // France
    DE: "eu", // Germany
    GR: "eu", // Greece
    HU: "eu", // Hungary
    IE: "eu", // Ireland
    IT: "eu", // Italy
    LV: "eu", // Latvia
    LT: "eu", // Lithuania
    LU: "eu", // Luxembourg
    MT: "eu", // Malta
    NL: "eu", // Netherlands
    PL: "eu", // Poland
    PT: "eu", // Portugal
    RO: "eu", // Romania
    SK: "eu", // Slovakia
    SI: "eu", // Slovenia
    ES: "eu", // Spain
    SE: "eu", // Sweden
    GB: "eu", // United Kingdom
  };
  
  export function getRegion(countryCode) {
    // Validate input
    if (typeof countryCode !== "string" || countryCode.length !== 2) {
      return regionMap["US"];
    }
    const code = countryCode.toUpperCase();
  
    // Return the region or null if not found
    return regionMap[code] || regionMap["US"];
  }
  export function getRegionName(countryCode) {
    // Validate input
    if (typeof countryCode !== "string" || countryCode.length !== 2) {
      const region = regionMap["US"];
      return PaymentStrings.regionNameMap[region]
    }
    const code = countryCode.toUpperCase();
  
    // Return the region or null if not found
    const region = regionMap[code] || regionMap["US"];
    return PaymentStrings.regionNameMap[region]
  }

  export function getCountryName(countryCode) {
    const code = countryCode.toUpperCase();
    return PaymentStrings.countryNameMap[code] || PaymentStrings.countryNameMap["US"]
  }

  export async function ip2loc(ip) {
    const url = 'http://ip-api.com/json';
    const resp = await fetch(url, {
      method: 'GET',
    }).then(resp => {
        if (resp.status === 200) {
            return resp.json();
        }
        return {status: "failed", msg: resp.statusText};
    });
    if (resp.status === "success") {
      return resp.countryCode;
    }
    return "US";
  }